// Site-wide URL helpers. With no REACT_APP_*_URL variables set, every helper returns today's paths.
const trim = (u) => (u || "").trim().replace(/\/+$/, "");
const MAIN = trim(process.env.REACT_APP_MAIN_SITE_URL);
const BLOG = trim(process.env.REACT_APP_BLOG_URL);

const withSlash = (path = "/") => (path.startsWith("/") ? path : `/${path}`);

/* "/" = blog listing, "/<slug>" = a post. */
export function blogUrl(path = "/") {
  const p = withSlash(path);
  if (BLOG) return BLOG + p;
  return p === "/" ? "/blog" : p;
}

export const mainUrl = (path = "/") => MAIN + withSlash(path);

export const isBlogHost = () => !!BLOG && typeof window !== "undefined" && window.location.origin === BLOG;

/* Main-site page link: a full mainUrl on the blog host, otherwise the plain path (today's behaviour). */
export const mainHref = (path) => (isBlogHost() ? mainUrl(path) : path);

/* Path for client-side routing when href is relative or same-origin; null when it's another domain. */
export function internalPath(href) {
  if (!href) return null;
  if (href.startsWith("/") && !href.startsWith("//")) return href;
  try {
    const u = new URL(href);
    if (typeof window !== "undefined" && u.origin === window.location.origin) return `${u.pathname}${u.search}${u.hash}`;
  } catch { /* not a URL */ }
  return null;
}

/* Absolute URL for canonical tags. */
export const absoluteUrl = (href) => (/^https?:\/\//.test(href) ? href : `${window.location.origin}${withSlash(href)}`);
